// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.account_good[data-v-2656c173] {\n  color: rgb(27, 185, 27);\n  font-size: 12px;\n  line-height: 1;\n  margin-left: auto;\n  margin-top: 5px;\n}\n.form-input.form-input-error-1 input[data-v-2656c173]:not(.inp-left) {\n  border: 1px solid #FF0000;\n}\n", ""]);
// Exports
module.exports = exports;
